import { render, staticRenderFns } from "./MilestoneReDispatch.vue?vue&type=template&id=daf57220&"
import script from "./MilestoneReDispatch.vue?vue&type=script&lang=js&"
export * from "./MilestoneReDispatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports